// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-column[data-v-501766ec]{width:calc(100% + 15px);max-height:450px;overflow-y:auto}#home-panel-dropzone[data-v-501766ec]{min-height:126px}#home-panel-add-files[data-v-501766ec]{padding-top:40px}.dz-uploaded-file[data-v-501766ec]{cursor:default}.dropdown-menu.limited-height[data-v-501766ec]{max-height:250px;overflow-y:auto}@media (max-width:991px){.form-column[data-v-501766ec]{max-height:none}}", ""]);
// Exports
module.exports = exports;
